export default function homeMore() {
	let _btn = $('#js-list_more')
	let _target = _btn.data('target')
	let _targetList = $('#'+_target)

	_btn.click(function () {
		let _targetListTop = _targetList.offset().top
		$(this).toggleClass('is-open')
		$(this).parent('div').toggleClass('is-open')
		$(_targetList).toggleClass('is-open')
		$('html, body').animate({
			scrollTop : _targetListTop
		});
	});
}
